import { RootState } from '@/shared/store'

import { planningShiftsAdapter } from '../adapters/planningShiftsAdapter'

export const planningShiftsSelectors = planningShiftsAdapter.getSelectors<RootState>(
  (state) => state.planningShifts,
)
